// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__296u5","row":"Node_row__3wDCw","label":"Node_label__1dkmd","footer":"Node_footer__2WK8O"};